import React from "react";
import Button from "components/button/Button";
import { useDisclosure } from "@chakra-ui/hooks";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";

interface IDeleteModal {
  title: string;
  onCancel: () => void;
  onDelete?: () => void;
}

const DeleteModal: React.FC<IDeleteModal> = (props) => {
  const { title, onCancel, onDelete } = props;

  return (
    <div>
      <ModalHeader>Hapus Toko</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <div className="flex flex-col gap-3">
          <p className="text-base text-gray-700 dark:text-white">{title}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        {" "}
        <div className="flex gap-3">
          <Button
            size="fit"
            children="Batal"
            variant="gray"
            onClick={onCancel}
          />
          <Button
            size="fit"
            children={<span className="text-white">Ya, hapus</span>}
            variant="danger"
            onClick={onDelete}
          />
        </div>
      </ModalFooter>
    </div>
  );
};

export default DeleteModal;
